import React, { useEffect, useRef, useState } from 'react';
import styles from './Tooltip.module.scss';
import { sanitizeType } from '../../functions';

const Tooltip = ({ point, type, children }) => {
  const buttonRef = useRef();
  const windowSize = useRef([window.innerWidth, window.innerHeight]);
  const [tooltipPositionRight, setTooltipPositionRight] = useState(false);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (point?.osx === undefined) {
      const calculateTooltipPosition = () => {
        const isRight = buttonRef?.current?.getBoundingClientRect().left < windowSize.current[0] / 2;
        setTooltipPositionRight(isRight);
        mainImage.removeEventListener('load', calculateTooltipPosition, false);
      };

      const mainImage = buttonRef.current?.closest('section')?.querySelector('img');

      if (!!mainImage) {
        mainImage.addEventListener('load', calculateTooltipPosition, false);
        return () => {
          mainImage.removeEventListener('load', calculateTooltipPosition, false);
        };
      }
    }
  }, []);

  const handleToggle = () => {
    setIsActive((prevState) => !prevState);
  };

  return (
    <div
      style={point?.osx && point?.osy ? { left: point.osx + '%', top: point.osy + '%' } : {}}
      className={`${styles.pointWrapper} ${sanitizeType(type, styles)}`}
    >
      <button
        ref={buttonRef}
        className={`${styles.point} ${sanitizeType(type, styles)} ${isActive ? styles.activePoint : ''}`}
        onClick={handleToggle}
      />
      <div
        className={`${styles.pointTooltip} ${isActive ? styles.activeTooltip : ''}`}
        data-position-vertical={point?.osy === undefined ? '' : point.osy > 50 ? 'top' : 'bottom'}
        data-position-horizontal={
          point?.osx === undefined ? (tooltipPositionRight ? 'centerRight' : 'centerLeft') : point.osx > 50 ? 'left' : 'right'
        }
      >
        {children}
      </div>
    </div>
  );
};

export default Tooltip;
